import { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import MenuPopover from '../MenuPopover.js'

interface AccountAgeInterface {
  changed: boolean,
  valueChanged: ((v:number[])=>any),
  valueDays: number[],
}

export default function AccountAge(props: AccountAgeInterface) {
  // Check function accountAgeString for the coding of this state
  const [accountAgeRangeDays, setAccountAgeRangeDays] = useState<number[]>(props.valueDays);

  const accountAgeString = (valueDays: number): string => {
    if (valueDays===0) {
      return "now"
    } else if (valueDays<30) {
      return "1 month" ;
    } else if (valueDays<12*30) {
      return Math.floor(valueDays/30) + " months";
    } else if (valueDays<365) {
      return "1 year" ;
    } else {
      return Math.floor(valueDays/365) + " years";
    }
  };

  const onChange = (event: Event, newValue: number|number[], activeThumb: number) => { 
    if (Array.isArray(newValue)) {
      setAccountAgeRangeDays(newValue); 
      props.valueChanged(newValue);
    } else {
      throw new Error("Expecting multiple values");
    }
  };

  return (
    <MenuPopover changed={props.changed} title="Account age">
      <Box sx={{ margin: 4, width: 300 }}>
        <Slider
          getAriaLabel={() => 'Account age'}
          value={accountAgeRangeDays}
          onChange={onChange}
          max={(new Date().getFullYear()-2010)*365}
          valueLabelDisplay="auto"
        />
        <Typography>From {accountAgeString(accountAgeRangeDays[0])} to {accountAgeString(accountAgeRangeDays[1])} old</Typography>
        <Typography color='LightGrey'>(WARNING: this uses as reference always the current date - making an option to use last date in date range is planned)</Typography>
      </Box>
    </MenuPopover>
  )
}

AccountAge.propTypes = {
  changed: PropTypes.bool,
  valueChanged: PropTypes.func,
  value: PropTypes.array,
};
